export var NotificationType;
(function (NotificationType) {
    NotificationType["Error"] = "Error";
    NotificationType["Success"] = "Success";
    NotificationType["Warning"] = "Warning";
    NotificationType["Info"] = "Info";
})(NotificationType || (NotificationType = {}));
export const getNotificationTypeSortOrder = (type) => {
    switch (type) {
        case NotificationType.Error:
            return 0;
        case NotificationType.Success:
        case NotificationType.Warning:
            return 1;
        default:
            return 2;
    }
};
